import styled, { css } from "styled-components";
import { Form, Divider, Select, Icon, Button } from "antd";
import { PillButton, PrimaryButtonComponent,GhostButtonComponent, DisplayFlex } from "../../../../../../CommonComponents/commonStyles";

const styles = css`
  font-family: HelveticaNeue-Medium;
  font-size: 16px;
  color: #006778;
`;

const fontCommonStyle = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

const cursorPointer = css`
  cursor: pointer;
`;

export const BasicInfo = styled.div`
  ${fontCommonStyle}
  line-height: 1.25;
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  font-weight: ${props => props.fontWeight};
  margin-left: ${props => props.marginLeft};
  letter-spacing: 0.57px;
`;

export const BasicInfoMinMax = styled.div`
${fontCommonStyle}
font-family: HelveticaNeue-Bold;
margin-top: ${props => props.marginTop};
line-height: 1.5;   
content: none;
`;

export const Title = styled.div`
  font-family: BerkeleyStd-Medium;
  font-size: 24px;
  margin-top: ${props => props.marginTop};
  line-height: 1.17;
  color: #022737;
  padding-top: 6px;
`;
export const CheckboxContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.primary};
line-height: 1.5;
color: #505050;
font-style: normal;
font-stretch: normal;
letter-spacing: normal;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
  line-height: 1.57;
  letter-spacing: normal;
}`;


export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: 25px;
     margin-bottom: 25px;
}
`;

export const InputAddressWrapper = styled.div`
input,
.ant-select-selection--single {
height: 30px;
}
.ant-input{
  border: 1px solid #d4d4d4;
  border-radius: 0;
}
`;

export const GrantAgreementDropdown = styled(Select)`
&&&{
  .ant-select-arrow{
    background-color: #f5f5f5;
    color: #60606A
    width: 40px;
    height: 100%;
    top: 6px;
    bottom: 1px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1 px;
    border-left: 1px solid #d4d4d4;
  }
}
.ant-select-selection__rendered{
  margin-left: 20px;
}

.ant-select-selection {
  border-radius: 0px;
}

.ant-select-selection-selected-value{
  overflow: unset;
}
.ant-select-selection:hover,.ant-select-selection:focus {
  border-color: #d9d9d9;
  outline: none;
  box-shadow: none;
}

`;


export const CheckboxWrapper = styled.div`
 .ant-checkbox-wrapper{
display: flex;
}
.ant-checkbox-checked .ant-checkbox-inner{
  background-color: #006778;
  border-color: #006778;
}
.ant-checkbox{
  top: 4px;
}
margin-bottom: 20px;
`;

export const FormWrapper = styled.div`
margin-left: 25px;
`;

export const InputMargin = styled.div`
.ant-form-item{
  margin-bottom: 40px;
}
`;
export const FormContainer = styled(Form)`
  &&& {
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control{
        line-height: normal;
      }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    &&& {
    .ant-form-item{
      margin-bottom: 30px;
    }
  }
  }
`;

export const PillButtonAdd = styled(PillButton)`
  ${styles}
  font-size: 14px;
  background-color: #f5f5f5;
  margin-bottom: 16px;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export const SectionLastHeading = styled.h1`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: 24px;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: 20px;
    line-height: ${props => props.theme.lineHeight.h5};
  }
`;

export const GrantAgreementSectionLastHeading = styled(SectionLastHeading)`
margin-bottom: 15px;
letter-spacing: ${props => props.theme.letterSpacing.normal};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h5};
  margin-bottom: 5px;
}
`;

export const GrantAgreementInvestmentSectionLastHeading = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: 24px;
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.h5};
    line-height: ${props => props.theme.lineHeight.h5};
  }
  @media only screen and (max-width: 576px) {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    font-size: 20px;
    line-height: ${props => props.theme.lineHeight.h5};
  }
margin-bottom: 15px;
letter-spacing: ${props => props.theme.letterSpacing.normal};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h5};
  margin-bottom: 5px;
}
`;

export const InputWrapper = styled.div`
input,
.ant-select-selection--single {
height: 40px;
@media only screen and (max-width: 767px) and (min-width: 320px) {
  width: 100%;
}
}
.ant-input{
  border: solid 1px #d4d4d4;
  border-radius: 0;
}
`;

export const LabelWrapper = styled.span`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: 16px;
line-height: 1.25;
color: #505050;
font-weight: normal;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}
`;

export const GrantAgreementContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 16px;
  line-height: 1.25;
  color: #505050;
  margin-bottom: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    line-height: 1.57;
  }
`;

export const GrantAgreementSubContent = styled(GrantAgreementContent)`
margin-bottom: 50px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  line-height: 1.57;
  margin-bottom: 20px;
}
`

export const WrapLabel = styled.div`
&&& {
  .ant-form-item-label{
    margin-bottom: 6px;
   }
   @media only screen and (min-width: 320px) and (max-width: 767px) {  
    &&& {
      .ant-form-item-label{
        padding: 0;
       }
   }
}
`

export const SelectOptionWrapper = styled.div`
.ant-select-dropdown:after{
  background: red;
   bottom: 0;
}
font-family: ${props => props.theme.fontFamily.helveticaNeue};
color: ${props => props.theme.fontColors.thead};
font-size: 16px;
line-height: 2.15;
    padding: 4px 0;
    font-weight: normal;
    &:hover {
      color: #167f91;
    }
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
    }
`;

export const SelectDropdown = styled(SelectOptionWrapper)`
.ant-select-dropdown:after{
  background: red;
   bottom: 0;
}
  font-family: HelveticaNeue;
  font-size: 14px;
  letter-spacing: 0.6px;
  color: #606060;
`;

export const HideArrow = styled.div`
&&& .ant-select-dropdown:after{
  bottom: 0;
}
`;

export const GrantContentWrapper = styled.div`
position: relative;
left: 20px;
top: 5px;
font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  color: #505050;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    left: 0;
  }
`;

export const ContentWrapper = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: 1.5;
color: #505050;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: 14px;
}

`;
export const HideExtraHeader = styled.div`
.ant-table-thead {
  display: none;
}
`;

export const HideExtraFooter = styled.div`
.ant-table-footer {
  display: none;
}
`;

export const PoolNameWrapper = styled.div`
  margin-top:40px;
  margin-botton:40px;
`;

export const HidePlaceHolder = styled.div`
  .ant-table-placeholder{
    display: none;
  }
`;

export const SectionSpacingFirst = styled.div`
  margin-bottom: 3rem;
`;

export const InvestmentOptionWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: BerkeleyStd-Medium;
  font-size: 24px;
  letter-spacing: 0.7px;
  color: #022737;
  padding-left: 20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    padding-left: 0px;
    line-height: ${props => props.theme.lineHeight.h5};
    margin-bottom: 20px;
  }
`;

export const ComponentDivide = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: ${props => props.marginTop ? props.marginTop : "25px"};
     margin-bottom: ${props => props.marginBottom};
     background-color: #d4d4d4;
     @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-top: ${props => props.mT};
        margin-bottom: ${props => props.mB};
     }
}
`;

export const BackIcon = styled(Icon)`
  display: inline-block;
  position: relative;
  transition: left 0.2s;
  @media only screen and (max-width: 990px) {
    left: 5px;
  }
  @media only screen and (max-width: 576px) {
    left: 5px;
  }
`;

export const BackButton = styled(GhostButtonComponent)`
  &:hover ${BackIcon} {
    left: -5px;
  }
  width: ${props => props.width ? props.width : '150px'};
  margin-right: 15px;
  padding: 0 20px;
  font-size: ${props => props.theme.fontSize.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 991px) {
  width: ${props => props.mobHalfWidth ? "48%" : "100%"};;
  margin-right: 0;
  margin-bottom: 15px;
  &:last-child {
    margin-right: 0;
  }
}
`;

export const NavigationBtnContainer = styled.div`
  justify-content: space-between;
  & > div {
    display: flex;
    & button:nth-child(1) {
      margin-right: 1rem;
    }
  }

  @media only screen and (max-width: 991.92px) {
    flex-flow: wrap;
    & > button {
      flex-basis: 100%;
      margin-top: 0.75rem;
    }
  }
`;

export const TotalErrorMessage = styled.div`
float: right;
color:#f74c52;
margin-bottom:10px;
`;

export const PrimaryButtonComponentDisabled = styled(
  PrimaryButtonComponent
)`
  background-color: rgba(0, 103, 120, 0.3) !important;
  color: #ffffff !important;
`;


const buttonCommon = css`
  font-family: HelveticaNeue-CondensedBlack !important;
  font-size: 18px !important;
  line-height: 1.67 !important;
  letter-spacing: 1.1px !important;
  width: 150px !important;
  height: 50px !important;
  ${cursorPointer};
`;

export const DisplayFlexSpace = styled(DisplayFlex)`
  justify-content: space-between;
`;

export const DisplayFlexSpaceMobile = styled(DisplayFlexSpace)`
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : '30px'} ;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    padding-top: 16px;
    &.flex-row{
      flex-direction:row;
    }
  }
`;

export const DropDownWrapper = styled.div`
  width: 350px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 270px;
  }
`;